import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSearch = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSearch",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M380-320q-109 0-184-75t-76-185 76-184 184-76 185 76 75 184q0 44-14 83t-38 69l224 224q11 11 11 28t-11 28-28 11-28-11L532-372q-30 24-69 38t-83 14m0-80q75 0 128-52t52-128-52-127-128-53-127 53-53 127 53 128 127 52"
  })
}));